module.exports = __webpack_public_path__ + "static/img/igprog-awards.e84babd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/igprog-awards.png
// module id = M7P0
// module chunks = 0